"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _scene = require("../utils/scene");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Creates a scene that emphasizes one presenter on the left.
 * The rest of the presenters form grid on the right.
 * @param {Array} sources
 * @param {{}} sourceStyle
 */

function featuredPresenterBuilder(sources) {
  var sourceStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var TILE_MARGIN = _SceneLayouts.SCENE_WIDTH * 4 / 672;
  var camSources = (0, _scene.getCameraSources)(sources);
  return {
    // TODO: remove as it is unnecessary and unused and probably will be confused w/ mongo object IDs
    _id: 'sceneFeaturedPresenter',
    style: _objectSpread({}, _scene.COMMON_SCENE_STYLES),
    title: _SceneLayouts.FEATURED_PRESENTER.title,
    description: _SceneLayouts.FEATURED_PRESENTER.title,
    layers: camSources.map(function (source, sourceIndex) {
      var tileStyles = {};
      var sourceNum = sourceIndex + 1;
      var camSourceCount = Math.min(camSources.length, _scene.MAX_CAMERA_COUNT);
      var gridWidth = _SceneLayouts.SCENE_WIDTH * 375 / 672;
      var featuredWidth = _SceneLayouts.SCENE_WIDTH * 212 / 672;
      var featuredHeight = _SceneLayouts.SCENE_HEIGHT * 298 / 378;
      var masterTopOffset = _SceneLayouts.SCENE_HEIGHT * 40 / 378;
      var masterLeftOffset = _SceneLayouts.SCENE_WIDTH * 40 / 672;
      var featuredRightOffset = _SceneLayouts.SCENE_WIDTH * 5 / 672;
      var secondaryLeftOffset = masterLeftOffset + featuredWidth + featuredRightOffset;
      var bannerValues;
      var titleFontSize;
      var subTitleFontSize;
      var horizontalPadding;
      if (sourceNum === 1) {
        // Featured
        tileStyles = {
          top: masterTopOffset,
          width: featuredWidth,
          left: masterLeftOffset,
          height: featuredHeight
        };

        // Only the featured presenter should have the compact banner height
        bannerValues = (0, _scene.getSmallBannerLayout)(tileStyles.height, tileStyles.top);
        titleFontSize = 33;
        subTitleFontSize = 25;
      } else {
        var oneRowTileHeight = _SceneLayouts.SCENE_HEIGHT * 186 / 378;
        // Secondary
        if (camSourceCount <= 2) {
          // Just one secondary source
          tileStyles = {
            height: oneRowTileHeight,
            left: secondaryLeftOffset,
            width: _SceneLayouts.SCENE_WIDTH * 375 / 672,
            top: (_SceneLayouts.SCENE_HEIGHT - oneRowTileHeight) / 2
          };
          // Per UX request, horizontal padding is adjusted for smoother transition to 3+ speakers on stage in featured presenter layout.
          horizontalPadding = 1.5;
        } else {
          /**
           * Many secondary sources
           * less one for the featured source
           */
          var gridSourceNum = sourceNum - 1;
          var gridSourceIndex = sourceIndex - 1;
          var gridSourceCount = camSourceCount - 1;
          var gridConfig = _scene.gridConfigMap[gridSourceCount];
          var rawTileWidth = gridWidth / gridConfig.row1Count;
          var tileWidth = (gridWidth - TILE_MARGIN * (gridConfig.row1Count - 1)) / gridConfig.row1Count;
          var tileHeight = gridSourceCount === 2 ? oneRowTileHeight : (featuredHeight - TILE_MARGIN) / 2;
          var isRow1 = gridSourceNum <= gridConfig.row1Count;
          var topOffset = isRow1 ? gridConfig.row2Count === 0 ? (_SceneLayouts.SCENE_HEIGHT - tileHeight) / 2 : masterTopOffset : masterTopOffset + tileHeight + TILE_MARGIN;
          var row2ExtraLeftOffset = (gridWidth - rawTileWidth * gridConfig.row2Count) / 2;
          var leftOffset = isRow1 ? (tileWidth + TILE_MARGIN) * gridSourceIndex : (tileWidth + TILE_MARGIN) * (gridSourceIndex - gridConfig.row1Count) + row2ExtraLeftOffset;
          tileStyles = {
            top: topOffset,
            width: tileWidth,
            height: tileHeight,
            left: secondaryLeftOffset + leftOffset
          };
        }

        // Secondary sources use the full banner height
        bannerValues = (0, _scene.getLargeBannerLayout)(tileStyles.height, tileStyles.top);
        titleFontSize = camSourceCount > 3 ? 21 : 31;
        subTitleFontSize = camSourceCount > 3 ? 16 : 24;
      }
      var bannerPosition = (0, _scene.getPresenterBannerPosition)(tileStyles);
      var _bannerValues = bannerValues,
        bannerHeight = _bannerValues.bannerHeight,
        bannerTop = _bannerValues.bannerTop;
      var _getDynamicTitleStyle = (0, _scene.getDynamicTitleStyles)(bannerHeight),
        titleHeight = _getDynamicTitleStyle.titleHeight,
        subTitleHeight = _getDynamicTitleStyle.subTitleHeight,
        subTitleGap = _getDynamicTitleStyle.subTitleGap;
      return {
        _id: source._id,
        source: source,
        layer: {
          animation: _objectSpread(_objectSpread({}, _scene.HARD_CUT_ANIMATION), {}, {
            animate: _objectSpread(_objectSpread({}, _scene.HARD_CUT_ANIMATION.animate), {}, {
              top: tileStyles.top,
              left: tileStyles.left,
              width: tileStyles.width,
              height: tileStyles.height
            })
          }),
          style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _scene.COMMON_CAMERA_STYLES.styles), {}, {
            top: 0,
            left: 0,
            zIndex: sourceNum,
            position: 'absolute',
            mediaStyle: _objectSpread(_objectSpread({}, _scene.COMMON_CAMERA_STYLES.mediaStyles), {}, {
              width: tileStyles.width,
              height: tileStyles.height
            })
          }, tileStyles), sourceStyle), {}, {
            bannerStyles: _objectSpread(_objectSpread(_objectSpread({}, bannerPosition), _scene.extraPresenterBannerStyles), {}, {
              zIndex: sourceNum
            }, (0, _scene.getDynamicBannerStyles)(bannerHeight, titleHeight, subTitleHeight, subTitleGap, titleFontSize, subTitleFontSize, horizontalPadding)),
            bannerAnimation: _objectSpread(_objectSpread({}, _scene.PRESENTER_BANNER_ANIMATION), {}, {
              animate: _objectSpread(_objectSpread({}, _scene.PRESENTER_BANNER_ANIMATION.animate), {}, {
                top: bannerTop,
                left: bannerPosition.left
              })
            })
          })
        }
      };
    })
  };
}
var _default = exports["default"] = featuredPresenterBuilder;